import type { AdminUser } from "@src/domain/entities";
import type { IAdminLoginRepository } from "@src/domain/repositories/auth";

export class AdminLoginUseCase {
    private readonly adminLoginRepository: IAdminLoginRepository;

    constructor(adminLoginRepository: IAdminLoginRepository) {
        this.adminLoginRepository = adminLoginRepository;
    }

    async execute(forceRefresh = false): Promise<AdminUser | null> {
        try {
            return await this.adminLoginRepository.login(forceRefresh);
        } catch (error) {
            console.error(error);
            throw new Error("Failed to login Admin User");
        }
    }
}